import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FaqSection />
        <AboutSection />
        <AppSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <TopicsSection />
        <RankingSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}